export const MANUAL_BILLING_PAYMENT_METHOD_LABELS = {
  BANK_TRANSFER: 'Bank transfer',
  WISE: 'Wise',
  OTHER: 'Other',
} as const

export const ACCOUNT_ORG_BILLING_COPY = {
  SECTION_TITLE: 'Billing',
  MANUAL_PAYMENT_TITLE: 'Payment',
  EMPTY_INTRO:
    'No active subscription or payment on file yet. Choose a plan on the Plan tab, or add invoice details below for wire and enterprise billing.',
  STRIPE_CUSTOM_UNPAID_HINT:
    'Your custom plan is ready — complete payment on the Plan tab to activate.',
} as const
